import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { getCurrentLanguage, t } from '../../translation'

const SettingsList = ({
  disablePlaylistMenu,
  openHistoryHandler,
  openLanguageSettingHandler,
  openSaveFilesScreenHandler,
  openPlaylistHandler,
  settingsLinks,
  logOutHandler,
  openTrainingVideoHandler,
  isPro,
  isOnline,
}) => {
  const currentLanguage = getCurrentLanguage()

  let versionNumber = 'V2.28'

  return (
    <div className="popup_in right_pos_mod settings_mod">
      <ul className="popup_group right_level_mod" onClick={(e) => e.stopPropagation()}>
        {/* Button for my account */}
        <li className="popup_group_item">
          <Link
            to={!window.cordova ? `${t('links.VIEW_ACCOUNT')}` : '/access'}
            className="popup_group_link default_text"
          >
            {t('settings.VIEW_ACCOUNT')}
          </Link>
        </li>
        {/* Button for opening history */}
        <li className="popup_group_item">
          <button className="popup_group_link default_text" onClick={openHistoryHandler}>
            {t('settings.YOUR_HISTORY')}
          </button>
        </li>
        {/* Button for changing language */}
        <li className="popup_group_item">
          <button
            className="popup_group_link default_text"
            onClick={openLanguageSettingHandler}
          >
            <span>
              {t('settings.CHANGE_LANGUAGE') + ': '}
              <span className="popup_group_item_selected">
                {t(`settings.${currentLanguage.toUpperCase()}`)}
              </span>
            </span>
          </button>
        </li>
        {window.cordova && (
          <li className="popup_group_item">
            <button
              className="popup_group_link default_text save_files_mod"
              onClick={openSaveFilesScreenHandler}
            >
              {t('settings.SAVE_MUSIC_FILES_TO_DEVICE')}
            </button>
          </li>
        )}
        <li className="popup_group_item">
          <button
            className="popup_group_link default_text"
            disabled={disablePlaylistMenu}
            onClick={openPlaylistHandler}
          >
            {t('settings.MY_PLAYLIST')}
          </button>
        </li>
        {/* Button for open training video */}
        {isPro && isOnline && (
          <li className="popup_group_item">
            <button
              className="popup_group_link default_text"
              onClick={openTrainingVideoHandler}
            >
              {t('settings.TRAINING_VIDEO')}
            </button>
          </li>
        )}
        {/* Rest of the links in settings */}
        {settingsLinks.map(({ href, title }) => (
          <li key={title} className="popup_group_item">
            <a className="popup_group_link default_text" target="_blank" href={href}>
              {title}
            </a>
          </li>
        ))}
        {/* Button for logging out */}
        <li className="popup_group_item">
          <button className="popup_group_link default_text" onClick={logOutHandler}>
            {t('settings.LOG_OUT')}
          </button>
        </li>
        <div className="popup_version_number">{versionNumber}</div>
      </ul>
    </div>
  )
}

const mapStateToProps = ({
  auth: { isPro, isOnline },
  player: { playingPlaylistSong },
}) => ({
  isPro,
  isOnline,
  disablePlaylistMenu: typeof playingPlaylistSong === 'number',
})

export default connect(mapStateToProps)(SettingsList)

SettingsList.propTypes = {
  disablePlaylistMenu: PropTypes.bool.isRequired,
  isPro: PropTypes.bool.isRequired,
  isOnline: PropTypes.bool.isRequired,
  openTrainingVideoHandler: PropTypes.func.isRequired,
  logOutHandler: PropTypes.func.isRequired,
  openHistoryHandler: PropTypes.func.isRequired,
  openLanguageSettingHandler: PropTypes.func.isRequired,
  openSaveFilesScreenHandler: PropTypes.func.isRequired,
  openPlaylistHandler: PropTypes.func.isRequired,
  settingsLinks: PropTypes.array.isRequired,
}
